// src/pages/BulkListingGenerator/components/FloatingSkuDropdown.js
import React, { useRef, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import styles from './BulkFormHelper.module.css';

const FloatingSkuDropdown = ({
    skuList,
    selectedSku,
    selectSku,
    getSkuThumbnail,
    isOpen,
    setIsOpen,
}) => {
    const selectedIndex = skuList.findIndex(item => item.sku === selectedSku);
    const selectedItem = skuList.find(item => item.sku === selectedSku);
    const selectedThumbnail = getSkuThumbnail(selectedSku);
    const dropdownRef = useRef(null);

    // Click-outside to close
    useEffect(() => {
        if (!isOpen) return;
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen, setIsOpen]);

    return (
        <div className={styles.floatingSkuBlock} ref={dropdownRef}>
            <div
                className={styles.floatingSkuHeader}
                onClick={() => setIsOpen(!isOpen)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setIsOpen(!isOpen); } }}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                aria-haspopup="listbox"
            >
                <div className={styles.floatingSkuLabel}>
                    {selectedIndex + 1}/{skuList.length} Products
                </div>
                <div className={styles.floatingSkuCard}>
                    <div className={styles.floatingSkuImage}>
                        {selectedThumbnail ? (
                            <img src={selectedThumbnail} alt={selectedSku} />
                        ) : (
                            <div className={styles.floatingSkuImagePlaceholder} />
                        )}
                    </div>
                    <div className={styles.floatingSkuContent}>
                        <div className={styles.floatingSkuTitle}>
                            {selectedItem?.title || selectedSku}
                        </div>
                        <div className={styles.floatingSkuBadge}>SKU ID : {selectedSku}</div>
                    </div>
                    <div className={`${styles.floatingSkuChevron} ${isOpen ? styles.floatingSkuChevronOpen : ''}`}>
                        <FaChevronDown />
                    </div>
                </div>
            </div>

            {/* Dropdown List */}
            {isOpen && (
                <div className={styles.floatingSkuDropdown}>
                    {skuList.map((item, index) => {
                        const thumb = getSkuThumbnail(item.sku);
                        return (
                        <div
                            key={index}
                            className={`${styles.floatingSkuDropdownItem} ${item.sku === selectedSku ? styles.floatingSkuDropdownItemSelected : ''}`}
                            onClick={() => {
                                selectSku(item.sku);
                                setIsOpen(false);
                            }}
                        >
                            <div className={styles.floatingSkuDropdownImage}>
                                {thumb ? (
                                    <img src={thumb} alt={item.sku} />
                                ) : (
                                    <div className={styles.floatingSkuImagePlaceholder} />
                                )}
                            </div>
                            <div className={styles.floatingSkuDropdownContent}>
                                <div className={styles.floatingSkuDropdownTitle}>{item.title}</div>
                                <div className={styles.floatingSkuDropdownBadge}>SKU ID : {item.sku}</div>
                            </div>
                            {item.sku === selectedSku && (
                                <div className={styles.floatingSkuDropdownCheck}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7 0C3.15098 0 0 3.15083 0 7C0 10.8492 3.15083 14 7 14C10.8492 14 14 10.8492 14 7C14 3.15083 10.8492 0 7 0ZM9.55375 4.49815C9.94345 4.05763 10.613 4.64947 10.2233 5.09058L6.32807 9.50109C6.15922 9.69155 5.86417 9.70324 5.68189 9.52504L3.80002 7.68577C3.37761 7.27387 4.00276 6.63352 4.42401 7.04425L5.96996 8.55625L9.55375 4.49815Z" fill="#96C7FB"/>
                                    </svg>
                                </div>
                            )}
                        </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default React.memo(FloatingSkuDropdown);
